<template>
  <div>
    <label class="text-xs py-2 block">
      <template v-if="isReservation">Telefonnummer*</template>
      <template v-else
        >Telefonnummer{{
          (function () {
            let required = false;
            bins?.forEach((bin) => {
              if (bin.phoneRequired) required = true;
            });
            return required && !optional ? '*' : '';
          })()
        }}</template
      >
    </label>
    <CheckoutVeeFieldReservationPhone v-if="isReservation" />
    <CheckoutVeeFieldOrderOverviewPhone
      v-else-if="isOverview"
      :is-reservation="isReservation"
      :bins="bins"
      :optional="optional"
    />
    <CheckoutVeeFieldOrderInvoicePhone
      v-else-if="!shipping"
      :is-reservation="isReservation"
      :bins="bins"
      :optional="optional"
    />
    <CheckoutVeeFieldOrderShippingPhone
      v-else
      :is-reservation="isReservation"
      :bins="bins"
      :optional="optional"
    />
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  isReservation: {
    type: Boolean,
    default: () => {
      return inject('isReservation');
    },
  },
  bins: {
    type: Object,
  },
  optional: {
    type: Boolean,
    default: false,
  },
  shipping: {
    type: Boolean,
    default: false,
  },
  isOverview: {
    type: Boolean,
    default: false,
  },
});
</script>
